<template>
  <div class="d-flex flex-column justify-content-center login">
    <div class="form">
      <img class="logo" :src="require('../assets/images/logo-brand.png')" />
      <b-overlay :show="isLoading" bg-color="transparent" blur="2px">
        <template #overlay>
          <img src="@/assets/lottie/plant.gif" style="width: 5em" />
        </template>
        <ValidationObserver
          ref="form1"
          v-slot="{ handleSubmit }"
          v-if="step === 1"
        >
          <form
            @submit.prevent="handleSubmit(loginState)"
            autocomplete="off"
            class="p-0"
            id="form"
          >
            <b-form-group label="Email">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-mail-line"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  placeholder="user@email.com"
                  v-model="username"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Password">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-lock-password-line"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="********"
                  v-model="password"
                >
                  <!-- <input type="password" placeholder="********" v-model="password" /> -->
                </b-form-input>
                <template #append>
                  <b-button
                    @click="showPassword = !showPassword"
                    variant="light"
                    size="sm"
                  >
                    <i
                      :class="!showPassword ? 'ri-eye-off-line' : 'ri-eye-line'"
                    ></i>
                  </b-button>
                </template>
              </b-input-group>
              <b-button
                variant="link"
                @click="$router.push({ path: '/reset-password' })"
              >
                Lupa Password
              </b-button>
            </b-form-group>
            <b-form-group>
              <b-button
                :disabled="isLoading"
                variant="primary"
                type="submit"
                class="mr-3"
              >
                <i class="ri-login-circle-line"></i> Login
              </b-button>
              <b-button
                @click="$router.push({ path: '/register' })"
                variant="outline-primary"
              >
                Daftar
              </b-button>
            </b-form-group>
          </form>
        </ValidationObserver>
      </b-overlay>
      <!-- <ValidationObserver
        ref="form2"
        v-slot="{ handleSubmit }"
        v-if="step === 2"
      >
        <form
          @submit.prevent="handleSubmit(onSelectUP)"
          autocomplete="off"
          class="p-0"
          id="form"
        > -->
      <!-- <s-input
              v-model="selectedPU"
              :item="{
                classLabel: 'col pl-0',
                rowclass: 'mx-0',
                label: 'Unit Produksi',
                prefix: '',
                type: 'select',
                validation: [],
                placeholder: 'Semua Unit Produksi',
                api: 'production-unit',
                pointer: {
                  label: 'name',
                  code: 'id',
                  display: ['name']
                },
                nm: true,
                classItem: 'mb-5'
              }" /> -->
      <!-- 
          <b-form-group label="Perusahaan" v-if="$store.state.profile.role_code === 'SUPER-ADMIN'">
            <v-select
              class="v-select-40"
              :options="corporates"
              v-model="selectedCorporate"
              placeholder=""
              @open="getInitialCorporate"
            />
          </b-form-group>
          
          <b-form-group label="Unit Produksi">
            <v-select
              class="v-select-40"
              :options="productionUnits"
              v-model="selectedPU"
              placeholder=""
              @open="getInitialPU"
            />
          </b-form-group>
          
          <b-form-group>
            <b-button @click="step = 1" variant="outline-primary" class="mr-3">
              <i class="ri-arrow-left-s-line"></i>
            </b-button>
            <b-button
              :disabled="isLoading"
              variant="primary"
              type="submit"
              class="mr-3"
            >
              <i class="ri-login-circle-line"></i> Lanjutkan
            </b-button>
          </b-form-group> -->
      <!-- </form>
      </ValidationObserver> -->
    </div>

    <img
      v-if="false"
      :src="require('../../static/img/default/frame-login.svg')"
      class="login-frame"
    />
    <img
      v-if="false"
      :src="require('../assets/images/frame-login-1.png')"
      class="login-frame-1"
    />
  </div>
</template>
<script>
import "./login/login.scss";
import _ from "lodash";
import axios from "axios";
import mode from "@/mode.js";
export default {
  name: "login-page",
  data() {
    return {
      showPassword: false,
      step: 1,
      state: "signin",
      username: "",
      password: "",
      errorLogin: null,
      forgetEmail: null,
      showResendEmail: false,
      tmp_user: null,
      resendWaiting: 0,
      isLoading: false,
      tmpData: {},
      productionUnits: [],
      corporates: [],
      selectedCorporate: {},
      selectedPU: {
        label: "Semua Unit Produksi",
        value: -1,
      },
      isMobile: window.innerWidth < 600,
    };
  },

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },

    getInitialCorporate() {
      this.$_api.get("/lookup/corporate").then((response) => {
        let _corporates = [];
        for (const _c of response.data.data) {
          _corporates.push({
            ..._c,
            label: _c.name,
            value: _c.id,
          });
        }

        this.corporates = _corporates;
      });
    },

    getInitialPU() {
      this.$_api.get("/lookup/production-unit").then((response) => {
        let _productionUnits = [];
        for (const _pu of response.data.data) {
          _productionUnits.push({
            label: _pu.name,
            value: _pu.id,
          });
        }

        _productionUnits.unshift({
          label: "Semua Unit Produksi",
          value: -1,
        });
        this.selectedPU = {
          label: "Semua Unit Produksi",
          value: -1,
        };

        this.productionUnits = _productionUnits;
      });
    },

    // onSearchPU: _.debounce

    async onSelectUP() {
      // e.preventDefault()
      if (!this.selectedPU) {
        this.$_alert.error(null, "", "Pilih unit produksi terlebih dahulu");
        return;
      }

      if (
        this.$store.state.profile.role_code === "SUPER-ADMIN" &&
        !this.selectedCorporate
      ) {
        this.$_alert.error(null, "", "Pilih perusahaan terlebih dahulu");
        return;
      }

      this.isLoading = true;

      if (this.selectedPU && this.selectedPU.value !== -1) {
        this.$_api
          .get(`/view/production-unit/${this.selectedPU.value}`)
          .then(async (response) => {
            this.isLoading = false;
            let puModel = {
              id: response.data.id,
              code: response.data.code,
              name: response.data.name,
              phone: response.data.phone,
              email: response.data.email,
              address: response.data.address,
              description: response.data.description,
            };

            this.$store.commit("set", ["temporary_corporate_id", null, true]);
            this.$store.commit("set", ["production_unit", puModel, true]);
            this.$store.commit("set", ["temporary_up_id", puModel.id, true]);
            this.$store.commit("set", ["temporary_date", [], true]);

            if (this.$store.state.profile.role_code !== "SUPER-ADMIN") {
              await this.$store.dispatch("setModule");
              this.$router.push({ name: "main-module" });
            } else {
              this.onSelectCorporate();
            }
          })
          .catch((err) => {
            this.$_alert.error(err);
          });
      } else {
        let puModel = {
          id: "",
          code: "",
          name: "Semua Unit Produksi",
          phone: "",
          email: "",
          address: "",
          description: "",
        };

        this.$store.commit("set", ["temporary_corporate_id", null, true]);
        this.$store.commit("set", ["production_unit", puModel, true]);
        this.$store.commit("set", ["temporary_up_id", puModel.id, true]);
        this.$store.commit("set", ["temporary_date", [], true]);

        if (this.$store.state.profile.role_code !== "SUPER-ADMIN") {
          await this.$store.dispatch("setModule");
          this.$router.push({ name: "main-module" });
        } else {
          this.onSelectCorporate();
        }
      }
    },

    async onSelectCorporate() {
      let corporateData = this.corporates.find(
        (x) => x.value === this.selectedCorporate.value
      );

      if (!corporateData) {
        await this.$store.dispatch("setModule");
        this.$router.push({ name: "main-module" });
        return;
      }

      this.$_api
        .post("/switch/corporate", { corporate_id: corporateData.id })
        .then(async (res) => {
          this.$store.commit("set", ["_token", res.data.token, true]);
          this.$store.commit("set", [
            "temporary_corporate_id",
            corporateData.id,
            true,
          ]);
          this.$store.commit("set", [
            "corporate",
            {
              address: res.data.corporate.address,
              allow_guides: res.data.corporate.allow_guides,
              code: res.data.corporate.code,
              email: res.data.corporate.email,
              name: res.data.corporate.name,
              phone: res.data.corporate.phone,
            },
            true,
          ]);

          await this.$store.dispatch("setModule");
          this.$router.push({ name: "main-module" });
        });
    },

    loginState() {
      // e.preventDefault()
      if (this.username && this.password) {
        let data = { email: this.username, password: this.password };
        this.isLoading = true;
        axios
          .post(`${this.$_config.server[mode]}/login`, data)
          .then((res) => {
            this.isLoading = false;

            this.$_alert.success(this.$t("login.success"));
            // console.log('login success', res);
            if (res.data) this.saveProfile(res.data);
            else this.actionUser(res.data_user_before_login, res.message);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$_alert.error(err);
          });
        return;
      } else {
        this.errorLogin = "Username & Password harus diisi";
      }
    },
    actionUser(data, message) {
      this.tmp_user = data;
      if (data.status_code === "email_unverified") {
        this.showResendEmail = true;
        this.errorLogin = message;
      } else if (data.status_code === "email_verified") {
        this.$router.push({ name: "waiting-apps", params: { user: data } });
      }
    },
    resendVerification() {
      if (this.resendWaiting === 0) {
        this.$_api
          .post("/request_email_verification", this.tmp_user)
          .then((res) => {
            this.resendWaiting = 60;
            this.setWaiting();
          })
          .catch((err) => {
            this.errorLogin = err.data.message;
          });
      }
    },
    setWaiting() {
      setTimeout(() => {
        if (this.resendWaiting > 0) {
          this.resendWaiting--;
          this.$nextTick();
          this.setWaiting();
        }
      }, 1000);
    },
    async saveProfile(e) {
      try {
        this.isLoading = true;

        this.$store.commit("set", ["", e.user, true]);
        this.$store.commit("set", ["profile", e.user, true]);
        this.$store.commit("set", ["_token", e.token, true]);
        this.$store.commit("set", ["permission", e.tasks, true]);
        this.$store.commit("set", ["program_year", e.program_year, true]);
        if (e.user && e.user.role_code) {
          this.$store.commit("set", ["role_code", e.user.role_code, true]);
          this.$store.commit("set", ["role_name", e.user.role_name, true]);
          this.$_config.options.yearOptions = e.program_years;
        }
        await this.$store.dispatch("setModule");
        this.$router.replace({ path: "/" });
      } catch (err) {
        localStorage.clear();
        this.$_alert.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    forgetPassword() {
      this.$_api
        .post("/request_forgot_password", { email: this.forgetEmail })
        .then((res) => {
          this.forgetEmail = null;
          this.state = "forgot-success";
        })
        .catch((err) => {
          this.errorLogin = err.data.message;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/default-page/login.vue